import trackCartInteraction from '../../api/track/track-cart-interaction';
import { FAILURE_EVENTS, Metadata, SUCCESS_EVENTS } from './track-schema';

export const trackCartFailure = async (category, metadata: Metadata, value) => {
  try {
    const event = FAILURE_EVENTS[category](metadata, value);
    return await trackCartInteraction(
      category,
      event.target,
      event.label,
      event.metadata,
      event.value
    );
  } catch (err) {
    typeof window !== 'undefined' &&
      window['newrelic']?.noticeError('Error tracking cart failure - ', JSON.stringify(err));
  }
};

export const trackCartEvent = async (category, metadata: Metadata, value) => {
  try {
    const event = SUCCESS_EVENTS[category](metadata, value);
    return await trackCartInteraction(
      category,
      event.target,
      event.label,
      event.metadata,
      event.value
    );
  } catch (err) {
    typeof window !== 'undefined' &&
      window['newrelic']?.noticeError('Error tracking cart event - ', JSON.stringify(err));
  }
};
